export default {
  isMicrosoftBrowser() {
    if (this.isIEBrowser()) return true;
    else if (navigator.userAgent.indexOf('Edge') !== -1) return true;
    else return false;
  },

  isIEBrowser() {
    if (navigator.appName === 'Microsoft Internet Explorer' && navigator.userAgent.indexOf('MSIE') !== -1) return true;
    else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') !== -1) return true;
    else return false;
  },

  isOperaBrowser() {
    return typeof window.opr !== 'undefined';
  },

  isChromiumBrowser() {
    return window.chrome !== null && typeof window.chrome !== 'undefined';
  },

  isChromeBrowser() {
    const winNav = window.navigator,
      vendorName = winNav.vendor,
      // is Google Chrome on IOS
      isIOSChrome = winNav.userAgent.match('CriOS');

    return (
      isIOSChrome ||
      (this.isChromiumBrowser() && vendorName === 'Google Inc.' && !this.isOperaBrowser() && !this.isMicrosoftBrowser())
    );
  },
};
